import React, { Component } from "react";

import "./styles.css";

export default class Modal extends Component {
  componentDidMount() {
    document.body.style.overflow = "hidden";
    document.getElementsByTagName("html")[0].style.overflow = "hidden";
  }

  componentWillUnmount() {
    document.body.style.overflow = "initial";
    document.getElementsByTagName("html")[0].style.overflow = "initial";
  }

  _onBackdropClick = () => {
    const { onBackdropClick } = this.props;
    if (onBackdropClick) onBackdropClick();
  };

  render() {
    const { title, children, className, onClose } = this.props;

    return (
      <div
        className="Modal__backdrop"
        onClick={this._onBackdropClick}
        role="dialog"
      >
        <div
          className={`Modal__window ${className || ""}`}
          onClick={(e) => e.stopPropagation()}
          style={this.props.layoutConfig}
          role="dialog"
        >
          {title && (
            <div className="Modal__title">
              {title}

              <button onClick={onClose}>X</button>
            </div>
          )}
          <div className="Modal__content">{children}</div>
        </div>
      </div>
    );
  }
}
